import React, { useState } from "react";
import Modal from "./Modal";
import { useI18n } from "../i18n";
import { shopsAPI } from "../services/api";
import { APP_VERSION, lastError } from "../utils/clientErrors";

/**
 * "Report a problem": the person's own words, plus the page, language, app
 * version and the last error the browser saw — sent to the operator's inbox
 * and email. Nothing is sent without pressing Send.
 */
const ReportProblem = ({ onClose }) => {
  const { t, lang } = useI18n();
  const [message, setMessage] = useState("");
  const [state, setState] = useState("idle");
  const [error, setError] = useState("");

  const send = async (event) => {
    event.preventDefault();
    if (message.trim().length < 3) {
      setError(t("support.reportShort"));
      return;
    }

    setState("sending");
    setError("");

    try {
      await shopsAPI.reportProblem({
        message: message.trim(),
        page: `${window.location.pathname}${window.location.search}`,
        language: lang,
        app_version: APP_VERSION,
        last_error: lastError(),
      });
      setState("sent");
    } catch {
      setState("idle");
      setError(t("support.reportFailed"));
    }
  };

  return (
    <Modal title={t("support.reportTitle")} onClose={onClose} maxWidthClass="max-w-lg" zClass="z-[80]">
      {state === "sent" ? (
        <div className="space-y-4">
          <p className="text-gray-700">{t("support.reportThanks")}</p>
          <button
            type="button"
            onClick={onClose}
            className="bg-primary-600 hover:bg-primary-700 text-white font-semibold px-4 py-2 rounded-lg"
          >
            {t("common.close")}
          </button>
        </div>
      ) : (
        <form onSubmit={send} className="space-y-4">
          <p className="text-sm text-gray-600">{t("support.reportIntro")}</p>
          <textarea
            rows={5}
            autoFocus
            aria-label={t("support.reportTitle")}
            maxLength={2000}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder={t("support.reportPlaceholder")}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
          {error && <p className="text-red-600 text-sm">{error}</p>}
          <div className="flex gap-3">
            <button
              type="submit"
              disabled={state === "sending"}
              className="bg-primary-600 hover:bg-primary-700 text-white font-semibold px-4 py-2 rounded-lg disabled:opacity-50"
            >
              {state === "sending" ? t("support.reportSending") : t("support.reportSend")}
            </button>
            <button type="button" onClick={onClose} className="text-gray-600 hover:underline">
              {t("support.reportCancel")}
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default ReportProblem;
